import { IJwtInterceptorsConfig } from 'common/axios/jwt/types';

let moduleConfig: IJwtInterceptorsConfig | null = null;

export const setConfig = (config: IJwtInterceptorsConfig): void => {
  moduleConfig = config;
};

export const getConfig = (): IJwtInterceptorsConfig | null => moduleConfig;
